import styled, { withTheme } from 'styled-components'
import { Truncate } from '../../../utils/style'
// import { rem } from 'polished'

const ColumnDescription = styled(Truncate)`
  color: ${(props) => props.theme.colors.grey_op80};
`

export default withTheme(ColumnDescription)
